import {
    Component,
    Injector,
    ViewEncapsulation,
    ViewChild,
    OnInit,
    OnDestroy,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import {
    BasketArticleDto,
    GetLocalWarehouseExtendedDataOutputDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

import { appModuleAnimation } from '@axilla/axilla-shared';
import * as _ from 'lodash-es';
import { take, repeat, filter, delay, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';

import {LocalWarehouseDataRow, MLWService} from '@app/webshop/shared/services/mlw.service';

import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-manage-local-warehouse-items',
    templateUrl: './manage-local-warehouse-items.component.html',
    styleUrls: ['./manage-local-warehouse-items.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class ManageLocalWarehouseItemsComponent extends AppComponentBase implements OnInit, OnDestroy {

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @Input() article: BasketArticleDto;

    @Output()
    addNew: EventEmitter<any> = new EventEmitter();

    @Output()
    rowUnselect: EventEmitter<any> = new EventEmitter();
    @Output()
    rowSelect: EventEmitter<any> = new EventEmitter();

    selectedProduct: any;

    get isAddMode(): boolean {
        return this.mLWService.isAddMode;
    }

    get unspecified(): number {
        return this.mLWService.getUnspecified();
    }

    protected readonly destroy$ = new Subject<void>();
    private mLWService: MLWService;

    constructor(
        injector: Injector
        , private fb: FormBuilder
    ) {
        super(injector);

        this.mLWService = injector.get(MLWService);
    }

    ngOnInit(): void {
        this.mLWService.itemsToShow$
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe((items: LocalWarehouseDataRow[]) => {
                if (items) {
                    this.setDataTable(items);
                }
            });

        this.getLocalWarehouseExtendedData();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    addNewRow() {
        this.mLWService.enableAddMode();
        this.addNew.emit();

        // const newRow = { tht: null, batchNumber: '', amount: 0 } as LocalWarehouseDataRow;
        // this.primengTableHelper.records = [newRow]; // Refresh table reference
    }

    apply() {
        this.mLWService.disableAddMode();
    }

    setDataTable(items: LocalWarehouseDataRow[]) {
        this.primengTableHelper.records = items;
        this.primengTableHelper.totalRecordsCount = items.length;
    }

    getLocalWarehouseExtendedData() {
        let userId = abp.session.userId;
        if (this.isGuided) {
            userId = abp.session.impersonatorUserId;
        }

        this.mLWService.getLocalWarehouseExtendedData$(userId, this.article.code)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe((result: GetLocalWarehouseExtendedDataOutputDto) => {

            });
    }

    onRowSelect(event: any) {
        this.mLWService.onRowSelect(event.data);
        this.rowSelect.emit()
    }

    onRowUnselect(event: any) {
        this.mLWService.onRowUnselect();
        this.rowUnselect.emit()
    }
}

